/*
 * @Descripttion:
 * @version:
 * @Author: Jianyong Wang
 * @Date: 2021-06-21 17:24:20
 * @LastEditors: zhangyang yang.zhang@corerain.com
 * @LastEditTime: 2023-03-09 15:48:02
 */
import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import routes from './routes'

const router = createRouter({
  // 指定路由模式
  history: createWebHashHistory(),
  // history: createWebHistory(),
  // 路由地址
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router
